import { SafeHaptics } from '@euler/utils';
import * as Clipboard from 'expo-clipboard';
import { memo, useCallback } from 'react';
import {
  GestureResponderEvent,
  TouchableOpacity,
  TouchableOpacityProps,
} from 'react-native';
import Toast from 'react-native-root-toast';

export const TouchCopyable = memo(
  ({
    text,
    children,
    onPress,
    ...props
  }: { text: string } & TouchableOpacityProps) => {
    const handlePress: TouchableOpacityProps['onPress'] = useCallback(
      (event: GestureResponderEvent) => {
        void Clipboard.setStringAsync(text);
        SafeHaptics.impact();
        Toast.show('已复制', {
          duration: 500,
          position: Toast.positions.CENTER,
        });
        onPress?.(event);
      },
      [onPress, text],
    );

    return (
      <TouchableOpacity onPress={handlePress} {...props}>
        {children}
      </TouchableOpacity>
    );
  },
);
